import { useId } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

export interface PatientActivityFilterProps {
  label: string;
  /** Presentation state: null shows all records. API mapping belongs to the caller. */
  active: boolean | null;
  onChange: (active: boolean | null) => void;
}

export const PatientActivityFilter = ({ label, active, onChange }: PatientActivityFilterProps) => {
  const labelId = useId();
  return (
    <FormControl fullWidth size="small" sx={{ minWidth: 140 }}>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        labelId={labelId}
        label={label}
        value={active === null ? 'all' : active ? 'active' : 'inactive'}
        onChange={event =>
          onChange(event.target.value === 'all' ? null : event.target.value === 'active')
        }
      >
        <MenuItem value="all">All</MenuItem>
        <MenuItem value="active">Active</MenuItem>
        <MenuItem value="inactive">Inactive</MenuItem>
      </Select>
    </FormControl>
  );
};
